export default function(fr = {}) {
    let photoUrl = (fr.photo || "").toString().trim();

    if( /^https?:\/\//gi.test(photoUrl) ) {
        return photoUrl;
    }

    let gender = (fr.gender || "m").toString().trim().toLowerCase();
    if(['m','male'].indexOf(gender) !== -1) {
        return "/assets/images/dude.jpg";
    } else {
        return "/assets/images/dudette.jpg";
    }
}
